import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { Follow } from './marketplace.models';
import { unwrapPage, Paginated } from './pagination.util';

@Injectable({ providedIn: 'root' })
export class FollowService {
  private apiUrl = serviceurl + 'api/v1/follows';

  constructor(private http: HttpClient) {}

  list(): Observable<Follow[]> {
    return this.http.get<Paginated<Follow> | Follow[]>(`${this.apiUrl}/`).pipe(unwrapPage<Follow>());
  }

  follow(vendorId: number): Observable<Follow> {
    return this.http.post<Follow>(`${this.apiUrl}/`, { vendor: vendorId });
  }

  unfollow(followId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${followId}/`);
  }
}
